import z from 'zod';

const coerceNumberSchema = z.coerce.number();

// TODO: NIM-22108 Remove completely and update usages to use number schema directly after frontend is fixed
export const preprocessStringNumberSchema = (innerSchema: z.Schema) =>
  z.preprocess((x, ctx) => {
    if (typeof x !== 'string') {
      return x;
    }

    if (x === '') {
      return undefined;
    }

    const result = coerceNumberSchema.safeParse(x);

    if (!result.success) {
      for (const issue of result.error.issues) {
        ctx.addIssue(issue);
      }

      return x;
    }

    return result.data;
  }, innerSchema);
